import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { auth } from '../firebase';
import './SignPage.css';

export default function SignUpPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      const displayName = `${firstName.trim()} ${lastName.trim()}`.trim();
      if (displayName) {
        await updateProfile(cred.user, { displayName });
      }
      navigate('/rrm');
    } catch (err) {
      console.error('Sign up error:', err);
      setError(err?.message || 'Failed to sign up');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sign-container">
      <div className="sign-left-panel">
        <div className="sign-background-image" />
        <div className="sign-left-content">
          <div className="sign-left-logo">RRMonitor</div>
          <h1 className="sign-left-title">Create Account</h1>
          <p className="sign-left-subtitle">
            Create an account to access the RRM comparison dashboard.
          </p>
        </div>
      </div>

      <div className="sign-right-panel">
        <div className="sign-card">
          <h2 className="sign-header">Sign Up</h2>
          {error && <div className="sign-error">{error}</div>}

          <form className="sign-form" onSubmit={handleSignUp}>
            <p className="sign-name-instruction">Enter your information.</p>
            <div className="sign-name-row">
              <div className="sign-input-group">
                <label htmlFor="firstName" className="sign-label">First Name</label>
                <input
                  id="firstName"
                  type="text"
                  className="sign-input"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
              <div className="sign-input-group">
                <label htmlFor="lastName" className="sign-label">Last Name</label>
                <input
                  id="lastName"
                  type="text"
                  className="sign-input"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="sign-input-group">
              <label htmlFor="email" className="sign-label">Email</label>
              <input
                id="email"
                type="email"
                className="sign-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            <div className="sign-input-group">
              <label htmlFor="password" className="sign-label">Password</label>
              <div className="sign-password-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  className="sign-input sign-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={6}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="sign-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  disabled={busy}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <div className="sign-button-group">
              <button type="submit" className="sign-button-login" disabled={busy}>
                {busy ? 'Creating…' : 'Sign Up'}
              </button>
              <button type="button" className="sign-button-help" onClick={() => navigate('/signin')} disabled={busy}>
                Back to Sign In
              </button>
            </div>
          </form>

          <div className="sign-bottom-link">
            Already have an account?{' '}
            <button className="sign-link-button-inline" type="button" onClick={() => navigate('/signin')}>
              Log in
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


